import script from "./ButtonBookmark.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonBookmark.vue?vue&type=script&setup=true&lang=js"

import "./ButtonBookmark.vue?vue&type=style&index=0&id=12fc6722&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12fc6722"]])

export default __exports__